import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SearchBar from '../detail/tabs/SearchBar';

const EditMeasurementCodeModal = ({
  isOpen,
  onClose,
  measurementInfo,
  currentCode,
  onPick,
  onSaveTerm,
  handleCodeSearch,
}) => {
  const [editableTerm, setEditableTerm] = useState('');

  useEffect(() => {
    if (isOpen) {
      setEditableTerm(currentCode?.terms?.[0] ?? '');
    }
  }, [isOpen, currentCode]);

  if (!isOpen || !measurementInfo) return null;

  const handleSaveTerm = () => {
    if (!currentCode) return;
    const trimmed = editableTerm.trim();
    onSaveTerm({
      ...currentCode,
      terms: trimmed ? [trimmed] : [],
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container modal-animated">
        <div className="modal-header">
          <h2>{measurementInfo.displayName}</h2>
          <button type="button" className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p className="retention-description" style={{ marginBottom: '12px' }}>
            {measurementInfo.description}
          </p>
          {currentCode && (
            <>
              <div className="current-code" style={{ marginBottom: '16px' }}>
                <span className="code-id">({currentCode.code})</span>
              </div>
              <label
                className="configured-code-term-label"
                htmlFor="measurement-configured-code-term-input"
              >
                Term
              </label>
              <input
                id="measurement-configured-code-term-input"
                type="text"
                className="configured-code-term-input"
                value={editableTerm}
                onChange={(e) => setEditableTerm(e.target.value)}
                placeholder="Enter preferred term"
                style={{ marginBottom: '16px' }}
              />
            </>
          )}
          <SearchBar
            placeholder="Search for a SNOMED code…"
            onSearch={handleCodeSearch}
            onResultClick={onPick}
            className="measurement-search-bar"
          />
        </div>
        <div className="modal-actions">
          <button type="button" className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          {currentCode && (
            <button type="button" className="admin-submit-button" onClick={handleSaveTerm}>
              Save term
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditMeasurementCodeModal;
